{
  "CONTACT_PANEL": {
    "CONFIRM": {
      "YES": "OK",
      "CANCEL": "Annuller"
    },
    "NOT_AVAILABLE": "Ikke Tilgængelig",
    "EMAIL_ADDRESS": "E-Mail Adresse",
    "PHONE_NUMBER": "Telefonnummer",
    "WHATSAPP_USERNAME": "WhatsApp-brugernavn",
    "IDENTIFIER": "Identifier",
    "COPY_SUCCESSFUL": "Kopiering til udklipsholder lykkedes",
    "COPY_NAME": "Kopier navn",
    "COPY_REFERER": "Kopier URL",
    "COMPANY": "Virksomhed",
    "LOCATION": "Lokation",
    "LTV": "LTV",
    "BROWSER_LANGUAGE": "Browser Sprog",
    "CONVERSATION_LANGUAGE": "Samtalesprog",
    "CONVERSATION_TITLE": "Samtaledetaljer",
    "VIEW_PROFILE": "Vis Profil",
    "BROWSER": "Browser",
    "OS": "Operativsystem",
    "INITIATED_FROM": "Startet fra",
    "INITIATED_AT": "Startet fra",
    "IP_ADDRESS": "Ip Adresse",
    "CREATED_AT_LABEL": "Created",
    "NEW_MESSAGE": "Ny besked",
    "CONVERSATIONS": {
      "NO_RECORDS_FOUND": "Der er ingen tidligere samtaler tilknyttet denne kontakt.",
      "TITLE": "Tidligere Samtaler"
    },
    "LABELS": {
      "CONTACT": {
        "TITLE": "Kontakt Labels",
        "ERROR": "Kunne ikke opdatere etiketter"
      },
      "CONVERSATION": {
        "TITLE": "Samtale Etiketter",
        "ADD_BUTTON": "Tilføj Labels"
      },
      "LABEL_SELECT": {
        "TITLE": "Tilføj Labels",
        "PLACEHOLDER": "Søg efter labels",
        "NO_RESULT": "Ingen labels fundet",
        "CREATE_LABEL": "Create new label"
      }
    },
    "MERGE_CONTACT": "Sammenflet kontakt",
    "CONTACT_ACTIONS": "Kontakt handlinger",
    "MUTE_CONTACT": "Block Contact",
    "MUTE_CONTACT_DISABLED": "Kan ikke bruges. Hele kontaktens domæne er blokeret.",
    "UNMUTE_CONTACT": "Unblock Contact",
    "BLOCK_CONTACT_DOMAIN": "Bloker kontaktens domæne",
    "UNBLOCK_CONTACT_DOMAIN": "Fjern blokering af kontaktens domæne",
    "BLOCK_CONTACT_DOMAIN_MESSAGE": "Blokering af domænet blokerer alle nuværende og fremtidige kontakter for dette domæne.",
    "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "Fjernelse af blokeringen af domænet fjerner blokeringen fra alle kontakter for dette domæne (inklusive dem, der er blokeret manuelt).",
    "MUTED_SUCCESS": "Denne kontakt er blevet blokeret. Kontaktens samtaler vil snart blive løst i baggrunden.",
    "UNMUTED_SUCCESS": "This contact is unblocked successfully.",
    "OPEN_JARABOT": "Åbn AI-svarhistorik",
    "TRANSLATE_CONVERSATION": "Oversæt samtale",
    "TRANSLATE_INITIATED": "Oversættelse påbegyndt. Det kan tage lidt tid for længere samtaler.",
    "TRANSLATE_SUCCESS": "Oversættelse af samtalen er fuldført.",
    "TRANSLATE_ERROR": "Kunne ikke oversætte samtalen. Prøv venligst igen.",
    "MOVE_CONVERSATION": "Flyt samtale",
    "MOVE_CONVERSATION_MISSING_EMAIL": "Kontaktens e-mailadresse er påkrævet for at flytte samtalen til en e-mailindbakke",
    "MERGE_CONVERSATION": "Sammenflet samtale",
    "CONTACT_DOMAIN_BLOCKED_SUCCESS": "Dette domæne er blevet blokeret. Du vil ikke blive underrettet om fremtidige samtaler.",
    "CONTACT_DOMAIN_UNBLOCKED_SUCCESS": "Blokeringen af dette domæne er blevet fjernet.",
    "SEND_TRANSCRIPT": "Send Udskrift",
    "EDIT_LABEL": "Rediger",
    "SIDEBAR_SECTIONS": {
      "CUSTOM_ATTRIBUTES": "Brugerdefinerede Egenskaber",
      "CONTACT_LABELS": "Kontakt Labels",
      "PREVIOUS_CONVERSATIONS": "Tidligere Samtaler",
      "NO_RECORDS_FOUND": "Ingen attributter fundet"
    },
    "BLOCK_PUBLIC_DOMAIN_TITLE": "Offentligt e-maildomæne",
    "BLOCK_PUBLIC_DOMAIN_MESSAGE": "{domain} er et offentligt e-maildomæne, som bruges af mange ikke-relaterede afsendere, og kan derfor ikke blokeres som helhed. Vil du kun blokere denne adresse ({email})?",
    "BLOCK_ONLY_THIS_ADDRESS": "Bloker kun denne adresse"
  },
  "EDIT_CONTACT": {
    "BUTTON_LABEL": "Rediger Kontakt",
    "TITLE": "Rediger Kontakt",
    "DESC": "Rediger kontaktoplysninger"
  },
  "DELETE_CONTACT": {
    "BUTTON_LABEL": "Slet Kontakt",
    "TITLE": "Slet kontakt",
    "DESC": "Slet kontaktoplysninger",
    "CONFIRM": {
      "TITLE": "Bekræft Sletning",
      "MESSAGE": "Er du sikker på du vil slette ",
      "YES": "Ja, Slet",
      "NO": "Nej, Behold"
    },
    "API": {
      "SUCCESS_MESSAGE": "Kontakten blev slettet",
      "ERROR_MESSAGE": "Kunne ikke slette kontakten. Prøv igen senere."
    }
  },
  "CONTACT_FORM": {
    "FORM": {
      "SUBMIT": "Gem",
      "CANCEL": "Annuller",
      "AVATAR": {
        "LABEL": "Kontakt Avatar"
      },
      "NAME": {
        "PLACEHOLDER": "Indtast det fulde navn på kontaktpersonen",
        "LABEL": "Fulde Navn"
      },
      "BIO": {
        "PLACEHOLDER": "Indtast kontaktens bio",
        "LABEL": "Bio"
      },
      "EMAIL_ADDRESS": {
        "PLACEHOLDER": "Indtast e-mailadressen på kontaktpersonen",
        "LABEL": "E-Mail Adresse",
        "DUPLICATE": "Denne e-mail adresse er i brug for en anden kontakt.",
        "ERROR": "Indtast venligst en gyldig e-mailadresse."
      },
      "PHONE_NUMBER": {
        "PLACEHOLDER": "Indtast telefonnummeret på kontaktpersonen",
        "LABEL": "Telefonnummer",
        "HELP": "Telefonnummer skal være af E.164 format fx: +1415555555 [+] [landekode] [områdekode] [lokalt telefonnummer]",
        "ERROR": "Telefonnummer skal være enten tomt eller i E.164-format",
        "DIAL_CODE_ERROR": "Please select a dial code from the list",
        "DUPLICATE": "Dette telefonnummer er i brug for en anden kontakt."
      },
      "LOCATION": {
        "PLACEHOLDER": "Angiv placeringen af kontaktpersonen",
        "LABEL": "Lokation"
      },
      "COMPANY_NAME": {
        "PLACEHOLDER": "Indtast virksomhedens navn",
        "LABEL": "Virksomhedens Navn"
      },
      "COUNTRY": {
        "PLACEHOLDER": "Enter the country name",
        "LABEL": "Land Navn",
        "SELECT_PLACEHOLDER": "Vælg",
        "REMOVE": "Fjern",
        "SELECT_COUNTRY": "Select Country"
      },
      "CITY": {
        "PLACEHOLDER": "Enter the city name",
        "LABEL": "City Name"
      },
      "SOCIAL_PROFILES": {
        "FACEBOOK": {
          "PLACEHOLDER": "Indtast Facebook brugernavn",
          "LABEL": "Facebook"
        },
        "TWITTER": {
          "PLACEHOLDER": "Indtast brugernavn til Twitter",
          "LABEL": "Twitter"
        },
        "LINKEDIN": {
          "PLACEHOLDER": "Indtast LinkedIn brugernavn",
          "LABEL": "LinkedIn"
        },
        "GITHUB": {
          "PLACEHOLDER": "Indtast Github brugernavn",
          "LABEL": "Github"
        }
      },
      "UNSAVED_CHANGES": {
        "TITLE": "Ikke-gemte ændringer",
        "DESCRIPTION": "Du har ikke-gemte ændringer. Vil du gemme dem, før du lukker?",
        "CONFIRM": "Gem",
        "CANCEL": "Kassér"
      }
    },
    "DELETE_AVATAR": {
      "API": {
        "SUCCESS_MESSAGE": "Kontakt avatar slettet",
        "ERROR_MESSAGE": "Kunne ikke slette kontakten avatar. Prøv igen senere."
      }
    },
    "SUCCESS_MESSAGE": "Kontakt gemt med succes",
    "ERROR_MESSAGE": "Der opstod en fejl. Prøv venligst igen"
  },
  "NEW_CONVERSATION": {
    "BUTTON_LABEL": "Start samtale",
    "TITLE": "Ny samtale",
    "DESC": "Start en samtale ved at sende en besked.",
    "NO_INBOX": "Kunne ikke finde en indbakke til at starte en ny samtale med denne kontakt.",
    "FORM": {
      "TO": {
        "LABEL": "Til"
      },
      "INBOX": {
        "LABEL": "Indbakke",
        "PLACEHOLDER": "Choose source inbox",
        "ERROR": "Vælg en indbakke"
      },
      "SUBJECT": {
        "LABEL": "Emne",
        "PLACEHOLDER": "Emne",
        "ERROR": "Emne må ikke være tomt"
      },
      "MESSAGE": {
        "LABEL": "Besked",
        "PLACEHOLDER": "Skriv din besked her",
        "ERROR": "Beskeden må ikke være tom"
      },
      "ATTACHMENTS": {
        "SELECT": "Choose files",
        "HELP_TEXT": "Drag and drop files here or choose files to attach"
      },
      "SUBMIT": "Send besked",
      "CANCEL": "Annuller",
      "SUCCESS_MESSAGE": "Besked sendt!",
      "GO_TO_CONVERSATION": "Vis",
      "ERROR_MESSAGE": "Kunne ikke sendes! prøv igen"
    }
  },
  "CONTACTS_PAGE": {
    "LIST": {
      "TABLE_HEADER": {
        "SOCIAL_PROFILES": "Social Profiles"
      }
    }
  },
  "CUSTOM_ATTRIBUTES": {
    "BUTTON": "Tilføj brugerdefineret attribut",
    "COPY_SUCCESSFUL": "Kopiering til udklipsholder lykkedes",
    "SHOW_MORE": "Show all attributes",
    "SHOW_LESS": "Show less attributes",
    "ACTIONS": {
      "COPY": "Kopier attribut",
      "DELETE": "Slet egenskab",
      "EDIT": "Rediger attribut"
    },
    "ADD": {
      "TITLE": "Opret brugerdefineret attribut",
      "DESC": "Tilføj brugerdefineret information til denne kontakt."
    },
    "FORM": {
      "CREATE": "Tilføj attribut",
      "CANCEL": "Annuller",
      "NAME": {
        "LABEL": "Brugerdefineret attributnavn",
        "PLACEHOLDER": "F. eks.: shopify id",
        "ERROR": "Ugyldigt brugerdefineret attributnavn"
      },
      "VALUE": {
        "LABEL": "Egenskab værdi",
        "PLACEHOLDER": "Eg: 11901 "
      },
      "ADD": {
        "TITLE": "Opret ny egenskab ",
        "SUCCESS": "Egenskab tilføjet",
        "ERROR": "Kan ikke tilføje attribut. Prøv igen senere"
      },
      "UPDATE": {
        "SUCCESS": "Attributten er opdateret",
        "ERROR": "Kan ikke opdatere attributten. Prøv igen senere"
      },
      "DELETE": {
        "SUCCESS": "Attributten blev slettet",
        "ERROR": "Kan ikke slette attributten. Prøv igen senere"
      },
      "ATTRIBUTE_SELECT": {
        "TITLE": "Tilføj attributter",
        "PLACEHOLDER": "Søg attributter",
        "NO_RESULT": "Ingen attributter fundet"
      },
      "ATTRIBUTE_TYPE": {
        "LIST": {
          "PLACEHOLDER": "Vælg værdi",
          "SEARCH_INPUT_PLACEHOLDER": "Søg værdi",
          "NO_RESULT": "Ingen resultater fundet"
        }
      }
    },
    "VALIDATIONS": {
      "REQUIRED": "Gyldig værdi er påkrævet",
      "INVALID_URL": "Ugyldig URL",
      "INVALID_INPUT": "Invalid Input"
    }
  },
  "MERGE_CONTACTS": {
    "TITLE": "Sammenflet kontakter",
    "DESCRIPTION": "Sammenflet kontakter for at kombinere to profiler til én, herunder alle attributter og samtaler. I tilfælde af konflikter vil den primære kontakts attributter have forrang.",
    "PRIMARY": {
      "TITLE": "Primær kontakt",
      "HELP_LABEL": "Skal slettes"
    },
    "PARENT": {
      "TITLE": "Kontakt for sammenfletning",
      "PLACEHOLDER": "Søg efter en kontakt",
      "HELP_LABEL": "Skal opbevares"
    },
    "SUMMARY": {
      "TITLE": "Oversigt",
      "DELETE_WARNING": "Kontakt af <strong>{primaryContactName}</strong> vil blive slettet.",
      "ATTRIBUTE_WARNING": "Kontaktoplysninger på <strong>{primaryContactName}</strong> vil blive kopieret til <strong>{parentContactName}</strong>."
    },
    "SEARCH": {
      "ERROR_MESSAGE": "Something went wrong. Please try again later."
    },
    "FORM": {
      "SUBMIT": " Sammenflet kontakter",
      "CANCEL": "Annuller",
      "CHILD_CONTACT": {
        "ERROR": "Vælg en underordnet kontakt at flette"
      },
      "SUCCESS_MESSAGE": "Kontakt flettet med succes",
      "ERROR_MESSAGE": "Kunne ikke sammenflette kontakter, prøv igen!"
    },
    "DROPDOWN_ITEM": {
      "ID": "(ID: {identifier})"
    }
  },
  "CONTACTS_LAYOUT": {
    "HEADER": {
      "TITLE": "Kontakter",
      "SEARCH_TITLE": "Search contacts",
      "SEARCH_PLACEHOLDER": "Search...",
      "MESSAGE_BUTTON": "Besked",
      "SEND_MESSAGE": "Send besked",
      "SHOW_DETAILS": "Kontaktoplysninger",
      "BLOCKING": "Blokering",
      "BLOCK_CONTACT": "Block contact",
      "UNBLOCK_CONTACT": "Unblock contact",
      "BLOCK_CONTACT_MESSAGE": "Hvis du blokerer denne kontakt, kan de ikke oprette nye samtaler, og alle deres eksisterende samtaler bliver løst. Er du sikker på, at du vil blokere denne kontakt?",
      "UNBLOCK_CONTACT_MESSAGE": "Hvis du fjerner blokeringen af denne kontakt, kan de oprette nye samtaler igen. Er du sikker på, at du vil fjerne blokeringen af denne kontakt?",
      "BLOCK_CONTACT_DOMAIN": "Bloker kontaktens domæne",
      "UNBLOCK_CONTACT_DOMAIN": "Fjern blokering af kontaktens domæne",
      "BLOCK_CONTACT_DOMAIN_MESSAGE": "Blokering af domænet blokerer alle nuværende og fremtidige kontakter for dette domæne.",
      "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "Fjernelse af blokeringen af domænet fjerner blokeringen fra alle kontakter for dette domæne (inklusive dem, der er blokeret manuelt).",
      "BREADCRUMB": {
        "CONTACTS": "Kontakter"
      },
      "ACTIONS": {
        "CONTACT_CREATION": {
          "ADD_CONTACT": "Add contact",
          "EXPORT_CONTACT": "Export contacts",
          "IMPORT_CONTACT": "Import contacts",
          "SAVE_CONTACT": "Save contact",
          "EMAIL_ADDRESS_DUPLICATE": "Denne e-mail adresse er i brug for en anden kontakt.",
          "PHONE_NUMBER_DUPLICATE": "Dette telefonnummer er i brug for en anden kontakt.",
          "SUCCESS_MESSAGE": "Kontakt gemt med succes",
          "ERROR_MESSAGE": "Unable to save contact. Please try again later."
        },
        "BLOCK_SUCCESS_MESSAGE": "Denne kontakt er blevet blokeret. Kontaktens samtaler vil snart blive løst i baggrunden.",
        "BLOCK_ERROR_MESSAGE": "Unable to block contact. Please try again later.",
        "UNBLOCK_SUCCESS_MESSAGE": "This contact is unblocked successfully",
        "UNBLOCK_ERROR_MESSAGE": "Unable to unblock contact. Please try again later.",
        "IMPORT_CONTACT": {
          "TITLE": "Import contacts",
          "DESCRIPTION": "Importér kontakter via en CSV-fil.",
          "DOWNLOAD_LABEL": "Download en prøve csv.",
          "LABEL": "CSV Fil:",
          "CHOOSE_FILE": "Choose file",
          "CHANGE": "Skift",
          "CANCEL": "Annuller",
          "IMPORT": "Importér",
          "SUCCESS_MESSAGE": "You will be notified via email when the import is complete.",
          "ERROR_MESSAGE": "Der opstod en fejl. Prøv venligst igen"
        },
        "EXPORT_CONTACT": {
          "TITLE": "Export contacts",
          "DESCRIPTION": "Quickly export a csv file with comprehensive details of your contacts",
          "CONFIRM": "Export",
          "SUCCESS_MESSAGE": "Export is in progress, You will be notified via email when export file is ready to dowanlod.",
          "ERROR_MESSAGE": "Der opstod en fejl. Prøv venligst igen"
        },
        "SORT_BY": {
          "LABEL": "Sorter efter",
          "OPTIONS": {
            "NAME": "Navn",
            "EMAIL": "E-mail",
            "PHONE_NUMBER": "Telefonnummer",
            "COMPANY": "Virksomhed",
            "COUNTRY": "Land",
            "CITY": "By",
            "LAST_ACTIVITY": "Last activity",
            "CREATED_AT": "Oprettet den"
          }
        },
        "ORDER": {
          "LABEL": "Ordering",
          "OPTIONS": {
            "ASCENDING": "Ascending",
            "DESCENDING": "Descending"
          }
        },
        "FILTERS": {
          "CREATE_SEGMENT": {
            "TITLE": "Vil du gemme dette filter?",
            "CONFIRM": "Gem filter",
            "LABEL": "Navn",
            "PLACEHOLDER": "Enter the name of the filter",
            "ERROR": "Enter a valid name",
            "SUCCESS_MESSAGE": "Filter saved successfully",
            "ERROR_MESSAGE": "Unable to save filter. Please try again later."
          },
          "DELETE_SEGMENT": {
            "TITLE": "Bekræft Sletning",
            "DESCRIPTION": "Are you sure you want to delete this filter?",
            "CONFIRM": "Ja, Slet",
            "CANCEL": "No, Cancel",
            "SUCCESS_MESSAGE": "Filter deleted successfully",
            "ERROR_MESSAGE": "Unable to delete filter. Please try again later."
          }
        }
      },
      "BLOCK_PUBLIC_DOMAIN_TITLE": "Offentligt e-maildomæne",
      "BLOCK_PUBLIC_DOMAIN_MESSAGE": "{domain} er et offentligt e-maildomæne, som bruges af mange ikke-relaterede afsendere, og kan derfor ikke blokeres som helhed. Vil du kun blokere denne kontakt ({email})?",
      "BLOCK_ONLY_THIS_CONTACT": "Bloker kun denne kontakt",
      "DIAL": "Ring op"
    },
    "PAGINATION_FOOTER": {
      "SHOWING": "Showing {startItem} - {endItem} of {totalItems} contacts"
    },
    "FILTER": {
      "NAME": "Navn",
      "EMAIL": "E-mail",
      "PHONE_NUMBER": "Telefonnummer",
      "IDENTIFIER": "Identifier",
      "COUNTRY": "Land",
      "CITY": "By",
      "CREATED_AT": "Oprettet den",
      "LAST_ACTIVITY": "Last activity",
      "REFERER_LINK": "Refererer link",
      "BLOCKED": "Blocked",
      "BLOCKED_TRUE": "Sandt",
      "BLOCKED_FALSE": "Falsk",
      "BUTTONS": {
        "CLEAR_FILTERS": "Clear filters",
        "UPDATE_SEGMENT": "Update segment",
        "APPLY_FILTERS": "Anvend filtre",
        "ADD_FILTER": "Add filter"
      },
      "TITLE": "Filtrer kontaktpersoner",
      "EDIT_SEGMENT": "Edit segment",
      "SEGMENT": {
        "LABEL": "Segment name",
        "INPUT_PLACEHOLDER": "Enter the name of the segment"
      },
      "ACTIVE_FILTERS": {
        "MORE_FILTERS": "+ {count} more filters",
        "CLEAR_FILTERS": "Clear filters"
      }
    },
    "CARD": {
      "OF": "of",
      "VIEW_DETAILS": "Se detaljer",
      "EDIT_DETAILS_FORM": {
        "TITLE": "Rediger kontaktoplysninger",
        "FORM": {
          "FIRST_NAME": {
            "PLACEHOLDER": "Enter the first name",
            "ERROR": "Fornavn er påkrævet."
          },
          "LAST_NAME": {
            "PLACEHOLDER": "Enter the last name"
          },
          "EMAIL_ADDRESS": {
            "PLACEHOLDER": "Enter the email address",
            "DUPLICATE": "Denne e-mail adresse er i brug for en anden kontakt.",
            "ERROR": "Indtast venligst en gyldig e-mailadresse."
          },
          "PHONE_NUMBER": {
            "PLACEHOLDER": "Enter the phone number",
            "DUPLICATE": "Dette telefonnummer er i brug for en anden kontakt."
          },
          "CITY": {
            "PLACEHOLDER": "Enter the city name"
          },
          "COUNTRY": {
            "PLACEHOLDER": "Select country"
          },
          "BIO": {
            "PLACEHOLDER": "Enter the bio"
          },
          "COMPANY_NAME": {
            "PLACEHOLDER": "Indtast virksomhedens navn"
          }
        },
        "UPDATE_BUTTON": "Update contact",
        "SUCCESS_MESSAGE": "Contact updated successfully",
        "ERROR_MESSAGE": "Unable to update contact. Please try again later."
      },
      "SOCIAL_MEDIA": {
        "TITLE": "Edit social links",
        "FORM": {
          "FACEBOOK": {
            "PLACEHOLDER": "Add Facebook"
          },
          "GITHUB": {
            "PLACEHOLDER": "Add Github"
          },
          "INSTAGRAM": {
            "PLACEHOLDER": "Add Instagram"
          },
          "WHATSAPP": {
            "PLACEHOLDER": "Tilføj WhatsApp"
          },
          "LINKEDIN": {
            "PLACEHOLDER": "Add LinkedIn"
          },
          "TWITTER": {
            "PLACEHOLDER": "Add Twitter"
          }
        }
      }
    },
    "DETAILS": {
      "CREATED_AT": "Created {date}",
      "LAST_ACTIVITY": "Last active {date}",
      "DELETE_CONTACT_DESCRIPTION": "Permanently delete this contact. This action is irreversible",
      "DELETE_CONTACT": "Slet kontakt",
      "DELETE_DIALOG": {
        "TITLE": "Bekræft Sletning",
        "DESCRIPTION": "Are you sure you want to delete this {contactName} contact?",
        "CONFIRM": "Ja, Slet",
        "API": {
          "SUCCESS_MESSAGE": "Kontakten blev slettet",
          "ERROR_MESSAGE": "Kunne ikke slette kontakten. Prøv igen senere."
        }
      },
      "AVATAR": {
        "UPLOAD": {
          "ERROR_MESSAGE": "Could not upload avatar. Please try again later.",
          "SUCCESS_MESSAGE": "Avatar uploaded successfully"
        },
        "DELETE": {
          "SUCCESS_MESSAGE": "Avatar slettet",
          "ERROR_MESSAGE": "Could not delete avatar. Please try again later."
        }
      }
    },
    "SIDEBAR": {
      "TABS": {
        "ATTRIBUTES": "Attributes",
        "HISTORY": "History",
        "NOTES": "Noter",
        "MERGE": "Merge",
        "ORDER_HISTORY": "Seneste ordrer",
        "RETINO": "Retino"
      },
      "HISTORY": {
        "EMPTY_STATE": "Der er ingen tidligere samtaler tilknyttet denne kontakt"
      },
      "ATTRIBUTES": {
        "SEARCH_PLACEHOLDER": "Search for attributes",
        "UNUSED_ATTRIBUTES": "{count} Used attribute | {count} Unused attributes",
        "EMPTY_STATE": "There are no contact custom attributes available in this account. You can create a custom attribute in settings.",
        "YES": "Ja",
        "NO": "Nej",
        "TRIGGER": {
          "SELECT": "Vælg værdi",
          "INPUT": "Enter value"
        },
        "VALIDATIONS": {
          "INVALID_NUMBER": "Invalid number",
          "REQUIRED": "Gyldig værdi er påkrævet",
          "INVALID_INPUT": "Invalid input",
          "INVALID_URL": "Ugyldig URL",
          "INVALID_DATE": "Invalid date"
        },
        "NO_ATTRIBUTES": "Ingen attributter fundet",
        "API": {
          "SUCCESS_MESSAGE": "Attributten er opdateret",
          "DELETE_SUCCESS_MESSAGE": "Attributten blev slettet",
          "UPDATE_ERROR": "Kan ikke opdatere attributten. Prøv igen senere",
          "DELETE_ERROR": "Kan ikke slette attributten. Prøv igen senere"
        }
      },
      "MERGE": {
        "TITLE": "Sammenflet kontakt",
        "DESCRIPTION": "Combine two profiles into one, including all attributes and conversations. In case of conflict, the primary contact’s attributes will take precedence.",
        "PRIMARY": "Primær kontakt",
        "PRIMARY_HELP_LABEL": "To be saved",
        "PRIMARY_REQUIRED_ERROR": "Please select a contact to merge with before proceeding",
        "PARENT": "To be merged",
        "PARENT_HELP_LABEL": "Skal slettes",
        "EMPTY_STATE": "No contacts found",
        "PLACEHOLDER": "Search for primary contact",
        "SEARCH_PLACEHOLDER": "Søg efter en kontakt",
        "SEARCH_ERROR_MESSAGE": "Could not search for contacts. Please try again later.",
        "SUCCESS_MESSAGE": "Kontakt flettet med succes",
        "ERROR_MESSAGE": "Kunne ikke sammenflette kontakter, prøv igen!",
        "IS_SEARCHING": "Søger...",
        "BUTTONS": {
          "CANCEL": "Annuller",
          "CONFIRM": "Sammenflet kontakt"
        }
      },
      "NOTES": {
        "PLACEHOLDER": "Tilføj en note",
        "WROTE": "wrote",
        "YOU": "Dig",
        "SAVE": "Save note",
        "EMPTY_STATE": "There are no notes associated to this contact. You can add a note by typing in the box above."
      }
    },
    "EMPTY_STATE": {
      "TITLE": "No contacts found in this account",
      "SUBTITLE": "Start adding new contacts by clicking on the button below",
      "BUTTON_LABEL": "Add contact",
      "SEARCH_EMPTY_STATE_TITLE": "Ingen kontakter matcher din søgning 🔍",
      "LIST_EMPTY_STATE_TITLE": "No contacts available in this view 📋"
    }
  },
  "COMPOSE_NEW_CONVERSATION": {
    "TITLE": "Ny samtale",
    "CONTACT_SEARCH": {
      "ERROR_MESSAGE": "We couldn’t complete the search. Please try again."
    },
    "FORM": {
      "GO_TO_CONVERSATION": "Vis",
      "SUCCESS_MESSAGE": "The message was sent successfully!",
      "ERROR_MESSAGE": "An error occurred while creating the conversation. Please try again later.",
      "NO_INBOX_ALERT": "There are no available inboxes to start a conversation with this contact.",
      "CONTACT_SELECTOR": {
        "LABEL": "Til:",
        "TAG_INPUT_PLACEHOLDER": "Search for a contact with name, email or phone number",
        "CONTACT_CREATING": "Creating contact..."
      },
      "INBOX_SELECTOR": {
        "LABEL": "Via:",
        "BUTTON": "Show inboxes"
      },
      "EMAIL_OPTIONS": {
        "SUBJECT_LABEL": "Emne :",
        "SUBJECT_PLACEHOLDER": "Enter your email subject here",
        "CC_LABEL": "Cc:",
        "CC_PLACEHOLDER": "Search for a contact with their email address",
        "BCC_LABEL": "Bcc:",
        "BCC_PLACEHOLDER": "Search for a contact with their email address",
        "BCC_BUTTON": "Bcc"
      },
      "MESSAGE_EDITOR": {
        "PLACEHOLDER": "Skriv din besked her..."
      },
      "WHATSAPP_OPTIONS": {
        "LABEL": "Select template",
        "SEARCH_PLACEHOLDER": "Search templates",
        "EMPTY_STATE": "No templates found",
        "TEMPLATE_PARSER": {
          "TEMPLATE_NAME": "WhatsApp template: {templateName}",
          "VARIABLES": "Variabler",
          "BACK": "Gå tilbage",
          "SEND_MESSAGE": "Send besked"
        }
      },
      "ACTION_BUTTONS": {
        "DISCARD": "Discard",
        "SEND": "Send ({keyCode})",
        "MARK_RESOLVED": "Markér den nye samtale som løst efter afsendelse",
        "SAVE_DRAFT": "Gem kladde",
        "CREATE_AS_INTERNAL": "Opret som samtale med note",
        "SEND_AND_RESOLVE_ORIGINAL": "Send og løs den oprindelige samtale ({keyCode})"
      },
      "DISCARD": "Kassér kladde",
      "DISCARD_MODAL": {
        "TITLE": "Kassér kladde",
        "DESCRIPTION": "Er du sikker på, at du vil kassere denne kladde?",
        "CONFIRM": "Ja, kassér",
        "CANCEL": "Nej, behold"
      }
    }
  }
}
